export enum CompositeProfileType {
    CompositeProfile = 0,
    PAG = 1,
    PerfilDeFacies = 2,
}
